// eslint-disable-next-line no-use-before-define
import React from 'react';
import { SVGWrapper } from '../../svg-wrapper/svg-wrapper';
import { DownloadIconSvg } from '../../../assets/icons/download';
import { ButtonContainer } from './style';
import useDownloadService from '../hook/use-download-service';
import { STATUS } from '@cora/download-center';
import { useTranslation } from 'react-i18next';
const DownloadDrawerButton = ({ onClick }) => {
    const { statusBadge } = useDownloadService();
    const { t } = useTranslation('drawerDownload');
    const colorBadge = () => {
        if (statusBadge === STATUS.Completed) {
            return 'red';
        }
        else if (statusBadge === STATUS.Processing) {
            return 'gray';
        }
        else {
            return '';
        }
    };
    return (React.createElement(ButtonContainer, null,
        React.createElement("div", { className: `badge ${colorBadge()}` }),
        React.createElement("button", { className: "tooltip", onClick: onClick },
            React.createElement("span", { className: "tooltiptext" }, t('drawerDownload:tooltipBtnDownload')),
            React.createElement(SVGWrapper, { svg: DownloadIconSvg }))));
};
export { DownloadDrawerButton };
//# sourceMappingURL=index.js.map